import React from 'react';
import Lookup from '../componentes/select2';
import { autobind } from 'core-decorators';

@autobind
class GrupoEmail extends React.Component {
  render() {
    return <Lookup labelKey="descricao" valueKey="id" url="/GrupoEmailLookup" {...this.props} />;
  }
}

export default GrupoEmail;
